import {Item} from '@ael/core-api';

export enum ValidationType {
  Error = 'error',
  Warning = 'warning',
}

export interface ValidationStatus {
  type: ValidationType;
  itemName: string;
  item: Item;

  /* Resource string to be translated */
  message: string;
}
